/**
 * https://vueuse.org/core/useBreakpoints/#usage
 */
export const useViewport = () => {
  const breakpoints = useBreakpoints({
    mobileS: 320,
    mobileM: 375,
    mobile: 480,
    tablet: 768,
    laptopS: 1024,
    laptop: 1440,
    desktop4K: 2560,
  });

  return {
    isMobile: breakpoints.smaller("mobile"),
    isTablet: breakpoints.between("mobile", "tablet"),
    isLaptop: breakpoints.between("tablet", "laptop"),
    isDesktop: breakpoints.greater("laptop"),
    bp: breakpoints,
  };
};
